//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FaqItems',
  props: {
    faqItems: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      active: []
    }
  },
  methods: {
    setActiveFAQ (number) {
      if (this.active.includes(number)) {
        this.active = this.active.filter(v => v !== number)
        return
      }
      this.active.push(number)
    }
  },
  jsonld () {
    const mainEntity = []
    if (this.faqItems.length) {
      this.faqItems.forEach(i => {
        mainEntity.push({
          '@type': 'Question',
          'name': i.question,
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': i.answer
          }
        })
      })
    }
    return mainEntity?.length ? {
      'name': 'Tubber',
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      'mainEntity': mainEntity
    } : null
  }
}
